// @flow

import { loaded } from '../middleware/apiCacheValidators';
import { Instrument, InstrumentList } from '../schema';
import { normalizeMetaItem, normalizeMetaList } from '../schema/normalizeMeta';

import type { Request } from './types';

export type LoadInstrumentsAction = { type: 'FETCH_INSTRUMENTS' } & Request;
export type LoadInstrumentAction = { type: 'FETCH_INSTRUMENT' } & Request;

export type InstrumentAction = LoadInstrumentsAction | LoadInstrumentAction;

export function loadInstruments(): LoadInstrumentsAction {
  return {
    type: 'FETCH_INSTRUMENTS',
    IDAGIO_REQUEST: {
      type: 'API_REQUEST',
      method: 'GET',
      endpoint: '/v2.0/metadata/instruments',
    },
    meta: {
      schema: InstrumentList,
      normalize: normalizeMetaList,
    },
    cache: {
      fetch: state => state.lists.instruments,
      validate: loaded,
    },
  };
}

export function loadInstrument(id: string): LoadInstrumentAction {
  return {
    type: 'FETCH_INSTRUMENT',
    cacheId: id,
    IDAGIO_REQUEST: {
      type: 'API_REQUEST',
      method: 'GET',
      endpoint: '/v2.0/metadata/instruments/{id}',
      params: { id },
    },
    meta: {
      schema: Instrument,
      normalize: normalizeMetaItem,
    },
    cache: {
      fetch: state => state.maps.instruments[id],
      validate: loaded,
    },
  };
}
